exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable button[data-v-24d952a0] {\n\ttext-decoration: underline;\n}\n.swiper-slide[data-v-24d952a0] {\n\twidth: auto;\n}\n.slide-item[data-v-24d952a0] {\n\twidth: 300px;\n\theight: 300px;\n\tbackground: aqua;\n\tborder-radius: 50%;\n}\n.page-inner[data-v-24d952a0] {\n\tpointer-events: none;\n}\n.page-inner > *[data-v-24d952a0] {\n\tpointer-events: auto;\n}\n", ""]);

// exports
